import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "help_flex" }
const _hoisted_2 = { class: "tree_box" }
const _hoisted_3 = { class: "tree_btn-list" }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "el-icon-plus" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 父级 ")
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "el-icon-plus" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 子级 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_10 = { class: "filter_input" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "show-input-box"
}
const _hoisted_13 = {
  key: 0,
  class: "help_content"
}
const _hoisted_14 = { class: "title_content" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("标题")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_18 = { class: "editor-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HelpSearchBar = _resolveComponent("HelpSearchBar")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_tree = _resolveComponent("el-tree")
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")
  const _component_v_md_editor = _resolveComponent("v-md-editor")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_HelpSearchBar, { onHelpScreenQuery: _ctx.getMenuList }, null, 8, ["onHelpScreenQuery"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            type: "primary",
            plain: "",
            onClick: _ctx.addTree,
            class: "add-tree"
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _hoisted_5
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            plain: "",
            onClick: _ctx.append,
            class: "add-tree"
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _hoisted_7
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.editNode
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "danger",
            onClick: _ctx.remove
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.filterText,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterText = $event)),
            placeholder: "输入关键字进行过滤"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_el_button, {
            type: "primary",
            class: "tree_add",
            onClick: _ctx.openTree
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.expandAll ? '收起' : '展开'), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createVNode(_component_el_scrollbar, { class: "scrollbar-height" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tree, {
              data: _ctx.menuDatas,
              "node-key": "id",
              ref: "treeRef",
              class: "customize-tree",
              "filter-node-method": _ctx.filterNode,
              "expand-on-click-node": false,
              "highlight-current": "",
              onNodeClick: _ctx.clickChildren,
              "allow-drop": _ctx.allowDrop,
              draggable: "",
              onNodeDrop: _ctx.handleDrop
            }, {
              default: _withCtx(({ data, node }) => [
                (!data.isEdit)
                  ? (_openBlock(), _createBlock("span", {
                      key: 0,
                      class: "custom-tree-node",
                      onDblclick: ($event: any) => (_ctx.dbclickItem(data))
                    }, [
                      _createVNode("span", null, _toDisplayString(data.cateName), 1),
                      (_ctx.currentSelectId == data.id)
                        ? (_openBlock(), _createBlock("span", _hoisted_11, [
                            _createVNode("i", {
                              class: "el-icon-edit",
                              onClick: ($event: any) => (_ctx.currentSelect(data))
                            }, null, 8, ["onClick"])
                          ]))
                        : _createCommentVNode("", true)
                    ], 40, ["onDblclick"]))
                  : (_openBlock(), _createBlock("div", _hoisted_12, [
                      _createVNode(_component_el_input, {
                        class: "tree_input",
                        modelValue: data.cateName,
                        "onUpdate:modelValue": ($event: any) => (data.cateName = $event),
                        ref: "inputRef",
                        placeholder: "请输入标题"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      _createVNode("i", {
                        class: "el-icon-circle-check",
                        onClick: ($event: any) => (_ctx.confirmAdd(data, node))
                      }, null, 8, ["onClick"]),
                      _createVNode("i", {
                        class: "el-icon-circle-close input-close",
                        onClick: ($event: any) => (_ctx.cancelAdd(data, node))
                      }, null, 8, ["onClick"])
                    ]))
              ]),
              _: 1
            }, 8, ["data", "filter-node-method", "onNodeClick", "allow-drop", "onNodeDrop"])
          ]),
          _: 1
        })
      ]),
      (_ctx.helpTitle)
        ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _createVNode(_component_el_input, {
                placeholder: "请输入内容",
                modelValue: _ctx.helpTitle,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.helpTitle = $event)),
                disabled: ""
              }, {
                prepend: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_button, {
                type: "danger",
                class: "btn-left",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.helpTitle = ''))
              }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _ctx.btnMarkdownSave
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createVNode("div", _hoisted_18, [
              _createVNode(_component_v_md_editor, {
                class: "editor-height",
                modelValue: _ctx.mdEditorMsg,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.mdEditorMsg = $event)),
                "disabled-menus": [],
                "right-toolbar": "preview sync-scroll fullscreen",
                onSave: _ctx.markdownSave,
                onUploadImage: _ctx.handleUploadImage,
                ref: "markdownRef"
              }, null, 8, ["modelValue", "onSave", "onUploadImage"])
            ])
          ], 512)), [
            [_directive_loading, _ctx.loading]
          ])
        : _createCommentVNode("", true)
    ])
  ], 64))
}